import type { MigrationStrategies } from "./_types/migration-strategies";

export const PRICE_ACKNOWLEDGEMENT_MIGRATION_STRATEGIES: MigrationStrategies = {
  1: (oldDoc) => oldDoc,
};
